import { useState } from "react";
import Input from "../components/Input"; 
import { T } from "../constants/theme";
import Btn from "../components/Btn";
import Badge from "../components/Badge";
export default function ForgotPasswordScreen  ({ onBackToLogin, onResetSuccess }) {
  const [stage, setStage] = useState("identify"); // identify -> otp -> reset -> done
  const [studentId, setStudentId] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(30);

  const maskedMobile = mobile ? mobile.slice(0, 2) + "XXXXX" + mobile.slice(-3) : "";

  const handleIdentify = () => {
    if (!studentId.trim()) { setError("Please enter your Student ID."); return; }
    if (!mobile.trim() || !/^[6-9]\d{9}$/.test(mobile)) { setError("Please enter a valid registered mobile number."); return; }
    setError(""); setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setStage("otp");
      startResendCountdown();
    }, 1200);
  };

  const startResendCountdown = () => {
    setResendTimer(30);
    const interval = setInterval(() => {
      setResendTimer(t => {
        if (t <= 1) { clearInterval(interval); return 0; }
        return t - 1;
      });
    }, 1000);
  };

  const handleVerifyOtp = () => {
    if (!otp.trim() || otp.length !== 6) { setError("Please enter the 6-digit OTP sent to your mobile."); return; }
    setError(""); setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setStage("reset");
    }, 1000);
  };

  const handleReset = () => {
    if (!newPassword) { setError("Please enter a new password."); return; }
    if (newPassword.length < 6) { setError("Password must be at least 6 characters."); return; }
    if (newPassword !== confirmPassword) { setError("Passwords do not match."); return; }
    setError(""); setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setStage("done");
    }, 1000);
  };

  return (
    <div style={{ background: `linear-gradient(160deg, ${T.indigo} 0%, ${T.indigoDark} 55%, #0D1F35 100%)`, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ width: "100%", maxWidth: 400 }}>
      
        <div style={{ background: T.white, borderRadius: 16, padding: "28px 28px 24px", boxShadow: "0 24px 60px rgba(0,0,0,0.35)" }}>

          {/* Stage: Identify */}
          {stage === "identify" && (
            <>
              <button onClick={onBackToLogin} style={{ background: "none", border: "none", color: T.gray600, fontSize: 13, cursor: "pointer", padding: 0, marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>
                ← Back to Login
              </button>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: T.indigo, marginBottom: 4 }}>Forgot Password?</h2>
              <p style={{ fontSize: 13, color: T.gray600, marginBottom: 22 }}>Enter your Student ID and registered mobile number. We'll send an OTP to verify your identity.</p>

              <Input label="Student ID" value={studentId} onChange={setStudentId} placeholder="e.g. STS000001" />
              <Input label="Registered Mobile Number" type="tel" value={mobile} onChange={setMobile} placeholder="10-digit mobile number" />

              {error && (
                <div style={{ background: T.redLight, border: `1px solid ${T.red}30`, borderRadius: 8, padding: "10px 12px", fontSize: 13, color: T.red, marginBottom: 16 }}>
                  ⚠ {error}
                </div>
              )}

              <Btn onClick={handleIdentify} disabled={loading} full>{loading ? "Sending OTP…" : "Send OTP"}</Btn>
            </>
          )}

          {/* Stage: OTP */}
          {stage === "otp" && (
            <>
              <button onClick={() => { setStage("identify"); setError(""); }} style={{ background: "none", border: "none", color: T.gray600, fontSize: 13, cursor: "pointer", padding: 0, marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>
                ← Back
              </button>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: T.indigo, marginBottom: 4 }}>Verify OTP</h2>
              <p style={{ fontSize: 13, color: T.gray600, marginBottom: 22 }}>
                A 6-digit OTP has been sent to <strong>{maskedMobile}</strong>.
              </p>

              <Input label="Enter OTP" value={otp} onChange={v => setOtp(v.replace(/\D/g, "").slice(0, 6))} placeholder="6-digit OTP" />

              {error && (
                <div style={{ background: T.redLight, border: `1px solid ${T.red}30`, borderRadius: 8, padding: "10px 12px", fontSize: 13, color: T.red, marginBottom: 16 }}>
                  ⚠ {error}
                </div>
              )}

              <Btn onClick={handleVerifyOtp} disabled={loading} full>{loading ? "Verifying…" : "Verify OTP"}</Btn>

              <div style={{ textAlign: "center", marginTop: 14 }}>
                {resendTimer > 0 ? (
                  <span style={{ fontSize: 12, color: T.gray400 }}>Resend OTP in {resendTimer}s</span>
                ) : (
                  <button onClick={startResendCountdown} style={{ background: "none", border: "none", color: T.saffron, fontSize: 12, fontWeight: 700, cursor: "pointer", padding: 0 }}>
                    Resend OTP
                  </button>
                )}
              </div>
            </>
          )}

          {/* Stage: Reset */}
          {stage === "reset" && (
            <>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: T.indigo, marginBottom: 4 }}>Create New Password</h2>
              <p style={{ fontSize: 13, color: T.gray600, marginBottom: 22 }}>Your identity has been verified. Set a new password for your account.</p>

              <Input label="New Password" type="password" value={newPassword} onChange={setNewPassword} placeholder="Min. 6 characters" />
              <Input label="Confirm New Password" type="password" value={confirmPassword} onChange={setConfirmPassword} placeholder="Re-enter new password" />

              {error && (
                <div style={{ background: T.redLight, border: `1px solid ${T.red}30`, borderRadius: 8, padding: "10px 12px", fontSize: 13, color: T.red, marginBottom: 16 }}>
                  ⚠ {error}
                </div>
              )}

              <Btn onClick={handleReset} disabled={loading} full>{loading ? "Updating…" : "Reset Password"}</Btn>
            </>
          )}

          {/* Stage: Done */}
          {stage === "done" && (
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: 48, marginBottom: 14 }}>✅</div>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: T.indigo, marginBottom: 6 }}>Password Reset Successful!</h2>
              <p style={{ fontSize: 13, color: T.gray600, marginBottom: 24 }}>
                Your password has been updated. You can now log in with Student ID <strong>{studentId}</strong> and your new password.
              </p>
              <Btn onClick={() => onResetSuccess(studentId)} full>Go to Login →</Btn>
            </div>
          )}

        </div>

        <p style={{ textAlign: "center", fontSize: 11, color: "rgba(255,255,255,0.35)", marginTop: 16 }}>
          Shabbas Academy · State-Level Examination Platform · Maharashtra
        </p>
      </div>
    </div>
  );
};